export type IncidentTriggerKind = string

export interface IncidentTrigger {
  kind: IncidentTriggerKind
  message: string
  stack: string
}

export interface IncidentDevice {
  os: 'android' | 'ios'
  osVersion: string
  brand: string
  model: string
}

export interface IncidentApp {
  name: string
  version: string
  configId: string
  configVersion: string
  screenId: string
}

export interface IncidentSession {
  stand: string
  userIdHash: string
  authenticated: boolean
}

export interface IncidentConnectivity {
  name: string
  url: string
  state: string
}

export interface IncidentReport {
  incidentId: string
  occurredAt: string
  sentAt: string
  trigger: IncidentTrigger
  device: IncidentDevice
  app: IncidentApp | null
  session: IncidentSession
  connectivity: IncidentConnectivity[]
  lines: string[]
  archivedAt?: string
}

export interface SearchReportsParams {
  query?: string
  limit: number
  offset: number
  archived?: boolean
}

export interface SearchReportsResult {
  items: IncidentReport[]
  total: number
  ttlDays?: number
}

export interface ArchiveReportsResult {
  moved: number
}

export interface ReportsFilters {
  os: '' | 'android' | 'ios'
  configId: string
  triggerKind: string
  message: string
  from: string
  to: string
}

export const EMPTY_REPORTS_FILTERS: ReportsFilters = {
  os: '',
  configId: '',
  triggerKind: '',
  message: '',
  from: '',
  to: '',
}
